import { render, staticRenderFns } from "./appointment-sucess.vue?vue&type=template&id=0e3e7b38&scoped=true"
import script from "./appointment-sucess.vue?vue&type=script&lang=ts"
export * from "./appointment-sucess.vue?vue&type=script&lang=ts"
import style0 from "./appointment-sucess.vue?vue&type=style&index=0&id=0e3e7b38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e7b38",
  null
  
)

export default component.exports